/// <amd-module name="Build/Common/Commands/deletedefinition/Command.types" />
import { BuildDefinitionReference } from "Build/Client/Contracts/Build";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentProperties } from "VSS/Platform/Layout";

export interface IDeleteDefinitionState {
    deletionConfirmed: boolean;
}

export interface IDeleteDefinitionProps extends IVssComponentProperties {
    pageContext: IVssPageContext;
    projectId: string;
    onClose: () => any;
    definition?: BuildDefinitionReference;
    onDefinitionDeleted?: (definition: BuildDefinitionReference) => any;
    path?: string;
    onFolderDeleted?: (path: string) => any;

}